import {RESET_STATE} from "../actions";

const metaData = (state = {}, {type, payload}) => {
    switch (type) {
        case RESET_STATE:
            return payload.metaData;
        default:
            return state;
    }
};

export default metaData;
